import { render, staticRenderFns } from "./Portail.vue?vue&type=template&id=6658e862"
import script from "./Portail.vue?vue&type=script&lang=js"
export * from "./Portail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports